import { checkoutReviewAndSubmitActionButtonsStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitActionButtons";
import { checkoutReviewAndSubmitHeaderStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import get from "@insite/mobius/utilities/get";
import getColor from "@insite/mobius/utilities/getColor";

import { changeCustomerSelectCustomerContainerStyles as buttonStyle } from "@tKgpco/Overrides/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

Object.assign(checkoutReviewAndSubmitActionButtonsStyles, {
    backButton: buttonStyle.cancelButton,
    placeOrderButton: {
        variant: "primary",
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.bold,
        },
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            text-transform: uppercase;
                            border-radius: 22px;
                            background-image: linear-gradient(to right, #44a8f7, ${COLORS.link.base});
                            border: none;
                            min-width: 120px;
                            color: ${COLORS.white};
                            & :hover {
                                background: ${COLORS.secondaryBtn};
                            }
                            &:disabled:hover {
                                background: ${COLORS.disabled.base};
                            }
                        `,
                        css`
                            display: none;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    submitForApprovalButton: {
        variant: "primary",
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.bold,
        },
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            text-transform: uppercase;
                            border-radius: 22px;
                            background-image: linear-gradient(to right, #44a8f7, ${COLORS.link.base});
                            border: none;
                            min-width: 120px;
                            color: ${COLORS.white};
                            & :hover {
                                background: ${COLORS.secondaryBtn};
                            }
                            &:disabled:hover {
                                background: ${COLORS.disabled.base};
                            }
                        `,
                        css`
                            display: none;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    buttonsWrapper: {
        css: css`
            display: none;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        display: flex;
                        position: fixed;
                        left: 0;
                        bottom: 0;
                        width: 100%;
                        background: ${getColor("common.background")({ theme })};
                        justify-content: center;
                        z-index: ${get(theme, "zIndex.stickyFooter")};
                        button {
                            width: 50%;
                        }
                    `,
                    css`
                        margin-left: 16px;
                    `,
                    css`
                        margin-left: auto;
                    `,
                    css`
                        margin-left: auto;
                    `,
                    css`
                        margin-left: auto;
                    `,
                ])}
        `,
    },
});
